export default {
  DURATION: 3000,
  DEPRECATED_PAGES: ['Chats', 'Chat', 'ChatShared', 'NewGptChat', 'SupportChat'],
}
